module.exports = __webpack_public_path__ + "img/54.87d5aa24.png";